import React, { useState } from "react";
import "../../styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faCalendarAlt,
  faChartPie,
  faClone,
  faFile,
  faKey,
  faLock,
  faPoll,
  faQuestionCircle,
  faReply,
  faStickyNote,
  faUsersCog,
} from "@fortawesome/free-solid-svg-icons";
import Navbar from "./Navbar";
import { Form, Modal, Button, Spinner, Col } from "react-bootstrap";
import firebase from "firebase";
import { sendEmail } from "../../utils/index";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";

import Courses from "./Courses";
import Events from "./Events";
import Rooms from "./Rooms";
import Blogs from "./Blogs";

toast.configure();

function RequestDemo() {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [country, setCounrty] = useState(null);
  const [countryCode, setCountryCode] = useState("us");
  const [details, setDetails] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    message: "",
    country: "",
  });
  const [phone, setPhone] = useState({ phone_code: "", phone_number: "" });
  const [saving, setSaving] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const isStringEmptyOrUndefined = (str) => {
    return str === "" || str === undefined;
  };

  const handleDetails = (e) => {
    setDetails((prev) => {
      let newObj = { ...prev, [e.target.name]: e.target.value };
      return newObj;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      isStringEmptyOrUndefined(details.first_name) ||
      isStringEmptyOrUndefined(details.email_address) ||
      isStringEmptyOrUndefined(phone.phone_code) ||
      isStringEmptyOrUndefined(phone.phone_number)
    ) {
      toast.error("Please enter values for all the (*) mandatory fields", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
      return;
    }

    let form_details = {
      ...details,
      country: details?.country ?? "",
      phone: { ...phone },
    };

    try {
      setSaving(true);
      await firebase
        .firestore()
        .collection("event-requests")
        .doc()
        .set(
          {
            ...form_details,
            timestamp: new Date().valueOf(),
          },
          { merge: true }
        );
      sendEmail({
        to: ["arani@igesia.co", "reena@igesia.co", "aroop@igesia.co"],
        subject: `Demo Request - ${form_details.first_name}`,
        content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;"><b>First name</b>: ${form_details.first_name} </span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;"><b>Last name</b>: ${form_details.last_name} </span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;"><b>Email address</b>: ${form_details.email_address} </span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;"><b>Contact number</b>: ${form_details.phone.phone_code} ${form_details.phone.phone_number} </span></p><p style="font-size: 14px; line-height: 140%;"> <br /><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;"><span style="line-height: 25.2px; font-size: 18px;"></span>Message: ${form_details.message}&nbsp;</span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]-->  <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://events.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,
        from: '"igesia" <noreply@igesia.co>',
      });
      history.push("/thank-you");
    } catch (e) {
      console.error(e);
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } finally {
      setSaving(false);
    }

    console.log("form details: ", form_details);
  };

  // useEffect(() => {
  //     setAccessCountryCode();

  //     let val = loadState("accessCountryName");
  //     setCounrty(val);

  //     setDetails((prev) => {
  //         let newObj = { ...prev, country: val };
  //         return newObj;
  //     });
  // }, [loadState("accessCountryName")]);

  // useEffect(() => {
  //     setCountryCode(loadState("accessCountryCode"));
  // }, [loadState("accessCountryCode")]);

  return (
    <>
      <a
        onClick={handleShow}
        style={{ background: "rgb(118, 60, 247)", borderRadius: "12px" }}
        className="btn text-white decoration-none font-weight-bold mb-3"
      >
        Request a Demo
      </a>

      <a
        onClick={() => history.push("/admin")}
        style={{ borderRadius: "12px" }}
        className="btn btn-light decoration-none font-weight-bold mb-3 ml-2"
      >
        Start Free Trial
      </a>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Request a Demo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Row>
                <Col>
                  <Form.Label>
                    First name<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="First name"
                    value={details.first_name}
                    name="first_name"
                    onChange={handleDetails}
                  />
                </Col>
                <Col>
                  <Form.Label>
                    Last name{" "}
                    <span className="small text-muted">(optional)</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Last name"
                    value={details.last_name}
                    name="last_name"
                    onChange={handleDetails}
                  />
                </Col>
              </Form.Row>
            </Form.Group>

            <Form.Group>
              <Form.Label>
                Email address<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email_address"
                value={details.email_address}
                onChange={handleDetails}
              />
              {false && (
                <Form.Text className="text-danger">
                  Please add a valid email.
                </Form.Text>
              )}
            </Form.Group>

            {/* <Form.Group>
                            <Form.Label>
                                Phone number<span className="text-danger">*</span>
                            </Form.Label>
                            <PhoneInput
                                inputClass="text-dark w-100"
                                name="phone_number"
                                country={countryCode?.toLowerCase()}
                                placeholder="Enter Phone Number"
                                value={phone && `${phone.phone_code}${phone.phone_number}`}
                                onChange={(phone, countryData) => {
                                    setPhone({
                                        phone_code: countryData.dialCode,
                                        phone_number: phone
                                            .replace(countryData.dialCode, "")
                                            .toString(),
                                    });
                                }}
                            />
                        </Form.Group> */}

            <Form.Group>
              <Form.Control
                type="hidden"
                placeholder="Country"
                value={details.country}
                name="country"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                Message <span className="small text-muted">(optional)</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter your message..."
                name="message"
                value={details.message}
                onChange={handleDetails}
              />
            </Form.Group>

            <Button variant="primary" type="submit" disabled={saving}>
              {saving ? <Spinner animation="border" size="sm" /> : "Submit"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

function Connect() {
  // useEffect(() => {
  //     console.log(Data);
  // }, []);
  return (
    <div className="overflow-hidden">
      <div className="container-fluid pt-3 pb-5 bg-gradient-colourful">
        <div className="container pb-4">
          <Navbar />

          <div className="row my-5">
            <div className="col-md-6 order-2 order-md-1">
              <div className="text-light">
                <h1 className="mb-3 text-s-1">
                  Supercharge your knowledge business
                </h1>
                <p className="text-s-6">
                  Create an engaged community of key stakeholders.
                </p>
                <RequestDemo />
                {/* <a
                                    href=""
                                    style={{ background: "rgb(118, 60, 247)", borderRadius: "12px" }}
                                    className="btn text-white decoration-none font-weight-bold mb-3"
                                >
                                    Request a Demo
                                </a> */}
                <br />
                {/* <a
                                    href=""
                                    style={{ background: "none", borderRadius: "12px" }}
                                    className="btn text-white decoration-none font-weight-bold mb-3"
                                >
                                    Explore</a> */}
                <a
                  href="/updates"
                  className="text-decoration-none d-inline-block mt-3"
                  style={{
                    background: "rgba(0, 0, 70, 0.12)",
                    transition: "background-color 200ms ease 0s",
                    padding: "6px 11px 6px 13px",
                    fontSize: "13px",
                    fontWeight: "500",
                    borderRadius: "50px",
                  }}
                >
                  <span style={{ color: "#DDDDDD" }}>What's New:</span>
                  <span style={{ color: "#EFEFEF" }}>
                    {" "}
                    Explore latest features and updates →
                  </span>
                </a>
              </div>
            </div>
            <div className="col-md-6 order-1 order-md-2 mb-4">
              <img
                style={{ paddingRight: "-400px", width: "100%" }}
                className="rounded"
                src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/igesia-event-stage.png"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="container-fluid py-5"
        style={{
          backgroundColor: "#FFFFFF",
          overflow: "hidden",
        }}
      >
        <div className="container py-5">
          <div className="row">
            <div className="col-md-12">
              <h2 className="mb-5 text-s-5 text-black-333 text-center">
                Join 30+ organisations in scaling your knowledge business
              </h2>
              <div className="row mt-3">
                <div className="col-md-2 col-6 mb-3">
                  <img
                    src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/special-olympics.jpg"
                    width="100%"
                  />
                </div>
                <div className="col-md-2 col-6 mb-3">
                  <img
                    src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/hci-maputo.jpg"
                    width="100%"
                  />
                </div>
                <div className="col-md-2 col-6 mb-3">
                  <img
                    src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/goa-university.jpg"
                    width="100%"
                  />
                </div>
                <div className="col-md-2 col-6 mb-3">
                  <img src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/cbse.jpg" width="100%" />
                </div>
                <div className="col-md-2 col-6 mb-3">
                  <img src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/gbsn.jpg" width="100%" />
                </div>
                <div className="col-md-2 col-6 mb-3">
                  <img src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/ida.jpg" width="100%" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container-fluid pt-5"
        style={{
          backgroundColor: "#17191A",
          overflow: "hidden",
        }}
      >
        <div className="container pt-5">
          <div className="row">
            <div className="col-md-9">
              <h2 className="mb-3 text-s-1 text-purple">
                An integrated platform for your{" "}
                <span style={{ color: "#FFFFFF" }}>knowledge business</span>.
              </h2>
              <p className="text-s-4" style={{ color: "#CCCCCC" }}>
                As the world moves towards a blended future, Igesia provides a
                unique integrated platform across in-person, live synchronous
                and asynchronous modes of interaction and learning. Build a
                custom platform by mixing and matching specific components to
                fit your needs. Provide valuable services. Measure key metrics.
                Engage your community.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container-fluid pb-5"
        style={{
          backgroundColor: "#17191A",
          overflow: "hidden",
        }}
      >
        <div className="container py-5">
          <div className="row mt-5">
            <Events />
            <Courses />
            <Rooms />
            <Blogs />
            <div className="col-md-12  mb-4">
              <div className="gradient-box bg-gradient-light pb-5">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="mb-3 text-s-7 text-purple">
                      Curate your community interactions.
                    </h3>
                    <p className="text-s-6">
                      <span style={{ color: "#333333" }}>
                        Provide a unique platform for your community members to
                        share ideas and interact with each other. Host blogs,
                        podcasts, videos and other community created knowledge
                        content.{" "}
                      </span>
                      <br /> <br />
                      <span style={{ color: "#888888" }}>
                        Promote conversations in Igesia rooms and offer rich
                        networking opportunities. Use Igesia video and other
                        productivity apps.{" "}
                      </span>
                    </p>

                    {/* <a
                                            // onClick={handleShow}
                                            href="/events"
                                            style={{ background: "rgb(118, 60, 247)", borderRadius: "12px" }}
                                            className="btn text-white decoration-none font-weight-bold mb-3"
                                        >
                                            Explore Events
                                        </a> */}
                    <RequestDemo />
                  </div>

                  <div className="col-md-6">
                    <div className="text-center">
                      <img
                        src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/igesia-community-page.png"
                        width="100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12  mb-4">
              <div className="gradient-box bg-gradient-light  pb-5">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="mb-3 text-s-7 text-warning">
                      Collaborate on projects.
                    </h3>
                    <p className="text-s-6">
                      <span style={{ color: "#333333" }}>
                        Create custom projects to enhance collaboration across
                        community members. Manage public and private access to
                        projects. Benefit from project management apps – such as
                        task assignments and deadlines built within Igesia.{" "}
                      </span>
                      <br /> <br />
                      <span style={{ color: "#888888" }}>
                        Build or link your own custom collaboration apps.
                        Monitor progress on projects.
                      </span>
                    </p>
                    {/* <a
                                                // onClick={handleShow}
                                                href="/courses"
                                                style={{ background: "rgb(118, 60, 247)", borderRadius: "12px" }}
                                                className="btn text-white decoration-none font-weight-bold mb-3"
                                            >
                                                Explore Projects
                                            </a> */}
                    <RequestDemo />
                  </div>
                  <div className="col-md-6">
                    <div className="text-center">
                      <img
                        src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/igesia-project.png"
                        width="100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12  mb-4 ">
              <div className="gradient-box bg-gradient-light pb-5">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="mb-3  text-s-7 text-success">
                      Offer virtual offices.
                    </h3>
                    <p className="text-s-6">
                      <span style={{ color: "#333333" }}>
                        Provide a customized virtual office for your key
                        community members. Schedule and offer paid consultations
                        for coaching and expert advice.{" "}
                      </span>
                      <br /> <br />
                      <span style={{ color: "#888888" }}>
                        Benefit from productivity apps and in-built Igesia
                        payment gateways and video. Showcase and sell your
                        unique knowledge content and services.
                      </span>
                    </p>
                    {/* <a
                                            // onClick={handleShow}
                                            href="/courses"
                                            style={{ background: "rgb(118, 60, 247)", borderRadius: "12px" }}
                                            className="btn text-white decoration-none font-weight-bold mb-3"
                                        >
                                            Explore Virtual Office
                                        </a> */}
                    <RequestDemo />
                  </div>
                  <div className="col-md-6">
                    <div className="text-center">
                      <img
                        src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/igesia-consultation.png"
                        width="100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12  mb-4">
              <div className="gradient-box bg-gradient-light pb-5">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="mb-3  text-s-7 text-secondary">
                      Host booths and stores.
                    </h3>
                    <p className="text-s-6">
                      <span style={{ color: "#333333" }}>
                        Allow your community sponsors and key stakeholders to
                        set up their customized booths and stores to showcase
                        and sell services and knowledge content.{" "}
                      </span>
                      <br /> <br />
                      <span style={{ color: "#888888" }}>
                        Benefit from in-built Igesia sales apps, payment
                        gateways and video for interactions with customers.
                      </span>
                    </p>
                    {/* <a
                                                // onClick={handleShow}
                                                href="/courses"
                                                style={{ background: "rgb(118, 60, 247)", borderRadius: "12px" }}
                                                className="btn text-white decoration-none font-weight-bold mb-3"
                                            >
                                                Explore Booths &amp; Stores
                                            </a> */}
                    <RequestDemo />
                  </div>
                  <div className="col-md-6">
                    <div className="text-center">
                      <img
                        src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/igesia-event-booth.png"
                        width="100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row mt-5">
                        <div className="col-md-6">
                            <p className="text-s-4 text-black-888">
                                Marketing tools to promote your business and engage with your your <span className="text-black-888">community</span>
                            </p>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-3 mb-4 col-6">
                            <div className="icon-box bg-white text-center w-100 h-100 py-4">
                                <span className="text-s-2 text-blue"><FontAwesomeIcon icon={faNewspaper} /></span>
                                <h5 className="text-s-8 mt-3 mb-0">Blogs</h5>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4 col-6">
                            <div className="icon-box bg-white text-center w-100 h-100 py-4">
                                <span className="text-s-2 text-purple"><FontAwesomeIcon icon={faPodcast} /></span>
                                <h5 className="text-s-8 mt-3 mb-0">Podcasts</h5>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4 col-6">
                            <div className="icon-box bg-white text-center w-100 h-100 py-4">
                                <span className="text-s-2 text-danger"><FontAwesomeIcon icon={faYoutube} /></span>
                                <h5 className="text-s-8 mt-3 mb-0">Videos</h5>
                            </div>
                        </div>
                    </div> */}
        </div>
      </div>

      <div
        className="container-fluid py-5"
        style={{
          backgroundColor: "#F7F7F7",
          overflow: "hidden",
        }}
      >
        <div className="container py-5">
          <div className="row">
            <div className="col-md-8">
              <h2 className="mb-3 text-s-1 text-danger">
                Applications designed to engage your community.
              </h2>
              <p className="text-s-4 text-black-333">
                Engagements is at the heart of igesia's architecture. These apps
                have been designed to not just engage with your community but
                measure them as well.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-blue">
                  <FontAwesomeIcon icon={faChartPie} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Poll</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-purple">
                  <FontAwesomeIcon icon={faLock} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Quiz</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-black-333">
                  <FontAwesomeIcon icon={faUsersCog} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Assignment</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-green">
                  <FontAwesomeIcon icon={faReply} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Gradebook</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-danger">
                  <FontAwesomeIcon icon={faClone} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Notes</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-black-333">
                  <FontAwesomeIcon icon={faBook} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Prescription</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-purple">
                  <FontAwesomeIcon icon={faPoll} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Case Sheet</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-primary">
                  <FontAwesomeIcon icon={faQuestionCircle} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Feedback</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-green">
                  <FontAwesomeIcon icon={faFile} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Certificates</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-blue">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Scheduling</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-warning">
                  <FontAwesomeIcon icon={faStickyNote} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Connect Rooms</h5>
              </div>
            </div>
            <div className="col-md-3 mb-4 col-6">
              <div className="icon-box bg-white text-center w-100 h-100 py-4">
                <span className="text-s-2 text-deep-green">
                  <FontAwesomeIcon icon={faKey} />
                </span>
                <h5 className="text-s-8 mt-3 mb-0">Encrypted Invite</h5>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-6">
              <p className="text-s-4 text-black-888">
                Connect to more than 3,000 apps using Zapier or native
                integrations <span className="text-black-333"></span>
              </p>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://cdn.zapier.com/ssr/6305d689f56390c169e2f73ab9b9fc1238d62d6c/_next/static/images/marketing/homepage/gmail.svg?auto=format&ar=undefined&fit=undefined&ixlib=react-9.0.2&w=3038"
                width="50%"
              />
            </div>
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://zapier-images.imgix.net/storage/services/7633e61620664fb3a71911729ebce5ea.png?auto=format&ixlib=react-9.0.2&ar=undefined&fit=crop&h=28&w=28&q=50&dpr=2"
                width="50%"
              />
            </div>
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://zapier-images.imgix.net/storage/services/221770b81f376004aee4a712ef4353be.png?auto=format&ixlib=react-9.0.2&ar=undefined&fit=crop&h=42&w=42&q=50&dpr=2"
                width="50%"
              />
            </div>
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://zapier-images.imgix.net/storage/services/580b3c79622bbff634f0d764e9f813a3.png?auto=format&ixlib=react-9.0.2&ar=undefined&fit=crop&h=42&w=42&q=50&dpr=2"
                width="50%"
              />
            </div>
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://zapier-images.imgix.net/storage/developer/472b2b8aba2dc38d4ef605c955341739_6.png?auto=format&ixlib=react-9.0.2&ar=undefined&fit=crop&h=28&w=28&q=50&dpr=2"
                width="50%"
              />
            </div>
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://zapier-images.imgix.net/storage/services/27f5433f521806493e2c38a304e1786e.png?auto=format&ixlib=react-9.0.2&ar=undefined&fit=crop&h=28&w=28&q=50&dpr=2"
                width="50%"
              />
            </div>
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://zapier-images.imgix.net/storage/developer/82e76b99c17c252653cee811b4e46123_2.png?auto=format&ixlib=react-9.0.2&ar=undefined&fit=crop&h=28&w=28&q=50&dpr=2"
                width="50%"
              />
            </div>
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://zapier-images.imgix.net/storage/services/8e760f76ff742d22fb037a3ed49e009d.png?auto=format&ixlib=react-9.0.2&ar=undefined&fit=crop&h=28&w=28&q=50&dpr=2"
                width="50%"
              />
            </div>
            <div className="col-md-1 col-3 mb-4">
              <img
                src="https://zapier-images.imgix.net/storage/services/c9ff916cf9e886f80b2a4a4ff35b9195.png?auto=format&ixlib=react-9.0.2&ar=undefined&fit=crop&h=28&w=28&q=50&dpr=2"
                width="50%"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="container-fluid py-5"
        style={{
          backgroundColor: "#17191A",
          overflow: "hidden",
        }}
      >
        <div className="container py-5">
          <div className="row">
            <div className="col-md-8">
              <h2 className="mb-3 text-s-1 text-green">
                How others are using igesia.
              </h2>
              <p className="text-s-4 text-light">
                30+ organisaions are using igesia to run live events, offer
                synchronous and asynchronous courses, consult and more. Discover
                some of their stories.
              </p>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-3 mb-4">
              <div className="gradient-box bg-white">
                <img
                  src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/cbse.jpg"
                  width="150"
                  className="mb-3"
                />
                <h3 className="mb-5 text-s-7 text-dark">
                  CBSE and Indian Orthodontic Society is using igesia for
                  preventive health teachers' training course
                </h3>
                {/* <p className="text-s-6">
                                    <span style={{ color: "#FFFFFF" }} >Supercharge your your schedule with igesia. </span>
                                    <span style={{ color: "#BBBBBB" }} >Connect with your existing systems - Practo, Google Calendar and others.</span>
                                </p>

                                <div style={{ width: "100%" }}>
                                    <img className=" mb-3" style={{}} src={`${process.env.PUBLIC_URL}/assets/igesia-doctor.png`} width="100%" />
                                </div> */}
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="gradient-box bg-white">
                <div className="row">
                  <div className="col-md-12">
                    <img
                      src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/goa-university.jpg"
                      width="150"
                      className="mb-3"
                    />
                    <h3 className="mb-5 text-s-7 text-dark">
                      Goa University is using igesia for its graduate courses
                    </h3>
                    {/* <p className="text-s-6">
                                            <span style={{ color: "#333333" }} >Digital prescriptions discoverable and organized. </span>
                                            <span style={{ color: "#888888" }} >Write them while consulting and share with the patient immediately. </span>
                                        </p> */}
                  </div>
                  {/* <div className="col-md-12 mb-3">
                                        <div style={{ width: "100%" }}>
                                            <img style={{}} src={`${process.env.PUBLIC_URL}/assets/igesia-prescription.png`} width="100%" />
                                        </div>
                                    </div> */}
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="gradient-box bg-white">
                <img
                  src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/boa.jpg"
                  width="150"
                  className="mb-3"
                />
                <h3 className="mb-5 text-s-7 text-dark">
                  Blue Ocean Awards is using igesia for its international awards
                  event
                </h3>
                {/* <p className="text-s-6">
                                    <span style={{ color: "#FFFFFF" }} >Supercharge your your schedule with igesia. </span>
                                    <span style={{ color: "#BBBBBB" }} >Connect with your existing systems - Practo, Google Calendar and others.</span>
                                </p>

                                <div style={{ width: "100%" }}>
                                    <img className=" mb-3" style={{}} src={`${process.env.PUBLIC_URL}/assets/igesia-doctor.png`} width="100%" />
                                </div> */}
              </div>
            </div>

            <div className="col-md-3 mb-4">
              <div className="gradient-box bg-white">
                <div className="row">
                  <div className="col-md-12">
                    <img
                      src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/gbsn.jpg"
                      width="150"
                      className="mb-3"
                    />
                    <h3 className="mb-5 text-s-7 text-dark">
                      Global Business School Network is using igesia for its
                      teachers' training course
                    </h3>
                    {/* <p className="text-s-6">
                                            <span style={{ color: "#333333" }} >Digital prescriptions discoverable and organized. </span>
                                            <span style={{ color: "#888888" }} >Write them while consulting and share with the patient immediately. </span>
                                        </p> */}
                  </div>
                  {/* <div className="col-md-12 mb-3">
                                        <div style={{ width: "100%" }}>
                                            <img style={{}} src={`${process.env.PUBLIC_URL}/assets/igesia-prescription.png`} width="100%" />
                                        </div>
                                    </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
}

export default Connect;
